import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../lib/api';
import * as mock from '../mock';

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const boot = await api.bootstrap();
      setData(boot);
    } catch (e) {
      setData(null); // fall back to mock
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const c = data?.collections || {};
  const s = data?.singletons || {};
  const pick = (arr, fallback) => (arr && arr.length ? arr : fallback);

  // Editorial content shows ONLY what's in the CMS — never fabricated mock data.
  const value = {
    loading,
    reload: load,
    topics: pick(c.topics, mock.topics),
    articles: c.articles || [],
    authoredArticles: c.authored || [],
    spotlights: c.spotlights || [],
    whatMadeNews: c.whatMadeNews || [],
    featuredEditions: c.featuredEditions || [],
    upcomingCoverStories: c.upcomingCoverStories || [],
    podcasts: (c.podcasts || []).map((p) => ({ ...p, videoId: p.videoId || p.id })),
    editions: c.editions || [],
    abcSpeakers: c.abcSpeakers || [],
    abcSponsors: c.abcSponsors || [],
    the100Leaders: (c.the100Leaders || []).filter((l) => l.name),
    coverStory: s.coverStory && Object.keys(s.coverStory).length ? s.coverStory : null,
    industryReport: s.industryReport && Object.keys(s.industryReport).length ? s.industryReport : null,
    enersiderBrief: s.enersiderBrief && Object.keys(s.enersiderBrief).length ? s.enersiderBrief : null,
    enersiderView: s.enersiderView && Object.keys(s.enersiderView).length ? s.enersiderView : null,
    newsmaker: s.newsmaker && Object.keys(s.newsmaker).length ? s.newsmaker : null,
    settings: s.settings || { digitalEditionUrl: mock.digitalEditionUrl },
    digitalEditionUrl: (s.settings && s.settings.digitalEditionUrl) || mock.digitalEditionUrl,
    eventsData: {
      conclave: s.conclave || mock.eventsData.conclave,
      felas: s.felas || mock.eventsData.felas,
      partners: pick(c.partnerEvents, mock.eventsData.partners),
    },
    iecl: s.iecl || {},
    the100: s.the100 || {},
    wire: (data?.wire && data.wire.length ? data.wire : []),
    sectors: (data?.sectors && data.sectors.length) ? data.sectors : ['Oil & Gas', 'GH2', 'BESS', 'RE (Solar + Wind)', 'Bio-Energy', 'Nuclear', 'Hydro', 'Thermal', 'Energy×Water', 'Energy×Infra', 'Power'],
    stats: mock.stats,
    partners: mock.partners,
    clubImage: mock.clubImage,
    clubImage2: mock.clubImage2,
    logoUrl: mock.logoUrl,
  };

  return <ContentContext.Provider value={value}>{children}</ContentContext.Provider>;
}

export function useContent() {
  const ctx = useContext(ContentContext);
  if (!ctx) throw new Error('useContent must be used within ContentProvider');
  return ctx;
}
